import { SistemaResponseModel } from "./sistemaResponseModel";

export class BuscarPorCodigoSistemaResponseModel {
  lstSistema : SistemaResponseModel[];

    constructor() {
      this.lstSistema = [];
    
    }
  }
  